Element.prototype.trigger = window.trigger = function(e, t = !1) {
    let o;
    o = t ? new CustomEvent(e, {
        detail: t
    }) : new Event(e), this.dispatchEvent(o)
}, Element.prototype.on = window.on = function(e, t, o = !1) {
    return this.namespaces || (this.namespaces = {}), e.split(" ").forEach(e => {
        this.namespaces[e] = t, this.addEventListener(e.split(".")[0], t, {
            passive: o
        })
    }), this
}, Element.prototype.off = window.off = function(e) {
    if (this.namespaces) return e.split(" ").forEach(e => {
        this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e]
    }), this
}, Element.prototype.index = function() {
    return [...this.parentNode.children].indexOf(this)
}, Element.prototype.offset = function() {
    var e = this.getBoundingClientRect();
    return {
        top: e.top + window.pageYOffset,
        left: e.left + window.pageXOffset
    }
}, Element.prototype.remove = function() {
    //custom storeify
    if(this.parentNode === null)
        return false
    //end custom
    return this.parentNode.removeChild(this)
}, NodeList.prototype.on = Array.prototype.on = function(e, o, n = !1) {
    this.forEach(t => {
        t.namespaces || (t.namespaces = {}), e.split(" ").forEach(e => {
            t.namespaces[e] = o, t.addEventListener(e.split(".")[0], o, {
                passive: n
            })
        })
    })
}, NodeList.prototype.off = Array.prototype.off = function(e) {
    this.forEach(t => {
        t.namespaces && e.split(" ").forEach(e => {
            t.removeEventListener(e.split(".")[0], t.namespaces[e]), delete t.namespaces[e]
        })
    })
}, NodeList.prototype.not = Array.prototype.not = function(t) {
    const o = [];
    return t instanceof HTMLElement && (t = [t]), this.forEach(e => {
        [...t].includes(e) || o.push(e)
    }), o
};
class Utilities {
    debounce(o, n) {
        let i;
        return function(...e) {
            const t = this;
            clearTimeout(i), i = setTimeout(() => n.apply(t, e), o)
        }
    }
    formatMoney(e) {
        var t = theme.settings.money_format.includes("no_decimals") ? 0 : 2,
            o = theme.settings.money_format.includes("comma") ? "de-DE" : "en-US";
        const n = Intl.NumberFormat(o, {
            minimumFractionDigits: t,
            maximumFractionDigits: t
        });
        o = n.format(e / 100);
        return theme.settings.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, o)
    }
    getHiddenElHeight(e, t = !0) {
        var o = e.style.padding;
        let n = document.createElement("div");
        var i = new RegExp(/\<.*[a-z]-root\s/gm),
            r = new RegExp(/\<\/.*[a-z]-root>/gm),
            r = (n.innerHTML = e.outerHTML.replace(i, "<div ").replace(r, "</div>"), (n = n.querySelector(":scope > *")).style.visibility = "hidden", n.style.display = "block", n.style.position = "absolute", n.style.padding = o, t && (i = e.offsetWidth, n.style.width = i + "px"), document.body.appendChild(n), n.offsetHeight);
        return n.remove(), r
    }
    getAvailableQuantity(e) {
        var t = e.querySelector("option[selected]");
        if ("shopify" !== t.dataset.inventoryManagement || "continue" === t.dataset.inventoryPolicy) return !0;
        var o = t.value,
            n = JSON.parse(localStorage.getItem(theme.local_storage.cart_items));
        let i;
        i = n[o] || 0;
        n = e.getAttribute("id");
        let r = parseInt(t.dataset.inventoryQuantity) - i,
            s;
        const a = document.querySelector(`.product-quantity--input[form='${n}']`);
        if (s = a ? parseInt(a.value) : 1, r <= 0) r = 0, a && (a.value = 1);
        else {
            if (!(s > r && a)) return !0;
            a.value = r
        }
        if (0 === r) window.location.hash = "#feedback-bar--product--no-items";
        else if (1 === r) window.location.hash = "#feedback-bar--product--one-item";
        else if (1 < r) {
            window.location.hash = "#feedback-bar--product--n-items";
            const l = document.querySelector('[data-message="product--n-items"]');
            l.textContent = l.textContent.replace("[num_items]", r)
        }
        return window.trigger("theme:feedbackBar:trigger"), !1
    }
    imagesLoaded(e, t) {
        let o = 0;
        const n = e.querySelectorAll('img[data-sizes="auto"]').length;
        n < 1 ? t() : e.on("lazybeforeunveil", e => {
            e.target.on("load", () => {
                ++o === n && t()
            })
        })
    }
    isTouchDevice() {
        return window.matchMedia("(pointer: coarse)").matches
    }
    libraryLoader(e, t, o) {
        if (void 0 === theme.libraries[e]) {
            theme.libraries[e] = "requested";
            const n = document.createElement("script");
            n.src = t, n.onload = () => {
                theme.libraries[e] = "loaded", o && o(), window.trigger(`theme:${e}:loaded`)
            }, document.body.appendChild(n)
        } else o && "requested" === theme.libraries[e] ? window.on(`theme:${e}:loaded`, o) : o && "loaded" === theme.libraries[e] && o()
    }
    matchImageHeights(e, c, d, h = !1) {
        if (c.length) {
            let n = !1;
            const m = [],
                p = [];
            if (c.forEach(e => {
                    const t = e.querySelector(d + ", .placeholder--container");
                    t && (t.style.height = "auto", n = n || t)
                }), n) {
                const u = Math.floor(e.offsetWidth / n.offsetWidth);
                if (!isNaN(u)) {
                    if (h) {
                        let o = 0;
                        h.forEach(e => {
                            var t = Math.floor((o + e.index()) / u) + 1,
                                e = Math.floor(e.offsetWidth / n.offsetWidth);
                            o += e - 1, m.includes(t) ? p[m.indexOf(t)] += e : (m.push(t), p.push(e))
                        })
                    }
                    let s = [],
                        a = 1,
                        l = 0;
                    c.forEach((e, t) => {
                        let o;
                        var n = e.querySelector(d + " .image--root"),
                            i = e.querySelector(".placeholder--container");
                        (o = n ? n.offsetHeight : i ? i.offsetHeight : 0) > l && (l = o);
                        let r = !1;
                        s.push(e), t + 1 === c.length ? r = !0 : h && m.includes(a) ? ((n = p[m.indexOf(a)]) === u ? a++ : r = s.length + n === u, 1 === n && 1 === u && (r = !0)) : s.length === u && (r = !0), r && (s.forEach(e => {
                            const t = e.querySelector(d + ", .placeholder--container");
                            t && (t.style.height = l + "px")
                        }), s = [], a++, l = 0)
                    })
                }
            }
        }
    }
    parseHtml(e, t) {
        const o = document.createElement("div");
        return o.innerHTML = e, t ? o.querySelector(t) : o.querySelector(":scope > *")
    }
    stylesheetLoader(e, t) {
        if (void 0 === theme.styles[e]) {
            theme.styles[e] = "loaded";
            const o = document.createElement("link");
            o.rel = "stylesheet", o.href = t, document.head.appendChild(o)
        }
    }
    updateRecentProducts(e) {
        var t = [e],
            o = localStorage.getItem(theme.local_storage.recent_products);
        let n, i, r = !1;
        o ? -1 === (n = JSON.parse(o)).indexOf(e) && (r = !0) : (i = JSON.stringify(t), localStorage.setItem(theme.local_storage.recent_products, i)), r && (4 === n.length && (n = n.slice(1)), i = JSON.stringify(n.concat(t)), localStorage.setItem(theme.local_storage.recent_products, i))
    }
}
theme.utils = new Utilities;